import React, { useState } from "react";
import "../../Styles/signin.css";
import { Link, useNavigate } from "react-router-dom";
import { IMAGES } from "../../utils/images";

const LoginForm = () => {
  const [formdata, setFormData] = useState({
    email: "",
    password: "",
  });
  const [passwordType, setPasswordType] = useState(true);
  const [validation, setValidation] = useState(false);
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const navigate = useNavigate();

  const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';
  const URL = `${API_URL}/api/auth/login`;
  
  const handleSubmit = async () => {
    // Basic validation
    if (!formdata.email.trim() || !formdata.password.trim()) {
      setErrorMessage("Please enter both email and password");
      setValidation(true);
      return;
    }
    
    try {
      setLoading(true);
      setValidation(false);
      setErrorMessage("");
      
      console.log('Making login request to:', URL);
      console.log('Request payload:', { email: formdata.email, password: '***' });
      
      const res = await fetch(URL, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formdata),
      });
      
      const responseText = await res.text();
      console.log('Login response status:', res.status);
      console.log('Login response headers:', Object.fromEntries(res.headers.entries()));
      console.log('Login response text:', responseText);
      
      let data;
      try {
        data = responseText ? JSON.parse(responseText) : {};
      } catch (e) {
        console.log('Failed to parse JSON response, using raw text');
        data = responseText;
      }
      
      if (res.ok) {
        // Store token and user info
        localStorage.setItem("token", data.token);
        localStorage.setItem("user", JSON.stringify(data.user));
        sessionStorage.setItem("authenticated", "true");
        navigate("/dashboard");
      } else {
        setValidation(true);
        // Handle not verified error
        if (data.message && data.message.toLowerCase().includes("verify your email")) {
          setErrorMessage("Please verify your email before logging in. Check your inbox for the verification link.");
        } else if (data.message) {
          setErrorMessage(data.message);
        } else {
          setErrorMessage('Login failed. Please try again.');
        }
      }
    } catch (err) {
      console.log("Error while submitting Form", err);
      setValidation(true);
      // Improved error handling: show backend error message if available
      if (err && err.message) {
        setErrorMessage(`Login failed: ${err.message}`);
      } else if (err && err.response && err.response.data && err.response.data.message) {
        setErrorMessage(`Login failed: ${err.response.data.message}`);
      } else {
        setErrorMessage("Login failed. Please try again later.");
      }
    } finally {
      setLoading(false);
    }
  };


  const handleChange = (e) => {
    setFormData({ ...formdata, [e.target.name]: e.target.value });
  };

  const handleForgotPassword = async () => {
    if (!formdata.email.trim()) {
      setErrorMessage("Please enter your email address to reset password");
      setValidation(true);
      return;
    }
    
    try {
      setLoading(true);
      const res = await fetch(`${API_URL}/api/auth/forgot-password`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ email: formdata.email }),
      });
      
      const msg = await res.text();
      
      if (res.ok) {
        alert("Password reset email has been sent. Please check your inbox.");
      } else {
        setValidation(true);
        setErrorMessage(msg);
      }
    } catch (err) {
      console.log("Error requesting password reset", err);
      setValidation(true);
      setErrorMessage("Password reset request failed. Please try again later.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="signin-left-container">
      <h1 className="signin-heading">Welcome Back</h1>
      <h2 className="signin-title">Log in to your account</h2>

        <label className="signup-label">Email</label>
        <input
          className={`signup-input ${validation && "error-input"}`}
          type="email"
          name="email"
          value={formdata.email}
          onChange={handleChange}
          placeholder="name@email.com"
        />
        <label className="signup-label">Password</label>
        <div className="password-container">
          <input
            className={`password-input ${validation && "error-input"}`}
            type={passwordType ? "password" : "text"}
            name="password"
            value={formdata.password}
            onChange={handleChange}
            placeholder="Enter your password"
          />
          <img
            src={passwordType ? IMAGES.PASSWORDCLOSE : IMAGES.PASSWORDOPEN}
            alt="eye"
            className="eye-icon"
            onClick={() => setPasswordType(!passwordType)}
          />
   
        
      </div>
      {validation && <p className="error-ind">{errorMessage}</p>}
        <div className="forgot-password">
          <button className="forgot-password" onClick={handleForgotPassword}>
            Forgot Password?
          </button>
        </div>
      <button 
        className="login-btn" 
        onClick={handleSubmit}
        disabled={loading}
      >
        {loading ? "Processing..." : "Log in"}
      </button>
      <h2 className="signin-btn">
        Don't have an account?
        <Link to="/signup">
          <button>Sign up</button>
        </Link>
      </h2>
    </div>
  );
};

export default LoginForm;
